<template>
    <div style="padding: 0 15px;">
      <!--左侧组织-->
      <div class="col_1 w540 left_height">
        <div style="padding-top: 20px;">
          <ul class="tabs">
            <li v-for="item in tabsData" :key="item.name" v-if="item.available" class="tabs-item" @click="current=item;">
              <a href="javascript:;" :class="[current==item ? 'current': '']">{{item.tabName}}</a>
            </li>
          </ul>
          <div class="tab_content">
            <!--Async :data="current" v-if="current"></Async-->
            <div v-show="current.name == 'org'">
              <!--tab1></tab1-->
              <div class="tab_content_semi" style="width: 240px;">
                <div v-if="!asyncFlag1" style="padding-top: 48px; text-align: center;">
                  <xo-loader :type="'cube'" :color="['#ff3634']" :size="{width: '32px', height: '32px'}" :font="{fontSize: '12px'}" :text="'载入组织架构中...'"></xo-loader>
                </div>
                <div v-if="asyncFlag1 && options.boxStyle.width">
                  <TreeView v-if="treemenu && treemenu.length > 0" :model="treemenu" @node-clicked="nodeClicked" :options="options"></TreeView>
                  <h5 class="none_ts" v-else>
                    <img src="@/assets/images/none_data.jpg" alt="">
                  </h5>
                </div>
              </div><!-- gap elimanated
              --><div class="tab_content_semi">
                    <div v-if="!asyncFlag2" style="padding-top: 48px; text-align: center;">
                      <xo-loader :type="'cube'" :color="['#ff3634']" :size="{width: '32px', height: '32px'}" :font="{fontSize: '12px'}" :text="'载入人员中...'"></xo-loader>
                    </div>
                    <div v-if="asyncFlag2" class="col_2 right_height" style="width: 100%; height:445px; margin-top: 0; box-sizing: border-box;">
                      <dl>
                        <dt>可选人员列表</dt>
                        <dd class="right_content" v-if="currentPeople.length > 0">
                          <p v-for="item in currentPeople" :key="item.id">
                            <a href="javascript:void(0);" class="right_content_a">
                              {{item.name}}
                              <input v-if="!params.hidePeople" type="checkbox" class="actions-select" :class="{'focus': item.selected }" @click="itemCheckedWithUI($event, $event.target.checked, item, '02')" v-model="item.selected" />
                            </a>
                          </p>
                        </dd>
                        <h5 class="none_ts" v-else>
                          <img src="@/assets/images/none_data.jpg" alt="">
                        </h5>
                      </dl>
                    </div>
              </div>
            </div>
            <div v-show="current.name == 'user'">
              <div class="col_2 right_height" style="width: 100%; padding-top: 5px; height:450px; margin-top: 0; box-sizing: border-box;">
                <input class="custom_input" v-model="userSearchFilter.name" type="text" placeholder="输入姓名"  />
                <span class="xo-table-btn" @click="userSearch(userSearchFilter)">搜索</span>
                <dl style="padding-top: 5px;">
                  <dd class="right_content" style="height: 400px" v-if="currentUsers.length > 0">
                    <p v-for="item in currentUsers" :key="item.id" style="display: inline-block;" class="wangwei-icon">
                      <a href="javascript:void(0);" class="right_content_a">
                        {{item.name}}
                        <input type="checkbox" class="actions-select actions-select-inline" :class="{'focus': item.selected }" @click="itemCheckedWithUI($event, $event.target.checked, item, '03')" v-model="item.selected" />
                      </a>
                    </p>
                  </dd>
                  <h5 class="none_ts" v-else>
                    <img src="@/assets/images/none_data.jpg" alt="">
                  </h5>
                  <div class="zy_list_bottom" style="margin-top: -45px;">
                    <dl>
                      <dt v-if="currentUsers.length > 0" style="padding-left: 0; float: right;">共{{cnt}}条记录</dt>
                      <dd v-if="currentUsers.length >0" style="float: left;">
                        <paginate v-if="pages > 0" :click-handler="clickCallback" :page-count=pages
                                  :container-class=$global.paginationOptions.container_class :page-class=$global.paginationOptions.page_class :page-link-class=$global.paginationOptions.page_link_class
                                  :prev-class=$global.paginationOptions.prev_class :prev-link-class=$global.paginationOptions.prev_link_class
                                  :next-class=$global.paginationOptions.next_class :next-link-class=$global.paginationOptions.next_link_class
                                  :first-last-button=$global.paginationOptions.first_last_button
                                  :active-class=$global.paginationOptions.active_class
                                  :disabled-class=$global.paginationOptions.disabled_class
                                  :first-button-text=$global.paginationOptions.first_button_text
                                  :last-button-text=$global.paginationOptions.last_button_text
                                  :prev-text=$global.paginationOptions.prev_text
                                  :next-text=$global.paginationOptions.next_text></paginate>
                      </dd>
                    </dl>
                  </div>
                </dl>
              </div>
            </div>
            <div v-show="current.name == 'role'">
              <div class="col_2 right_height" style="width: 100%; height:445px; margin-top: 0; box-sizing: border-box;">
                <dl>
                  <dd class="right_content" v-if="currentRoles.length > 0">
                    <p v-for="item in currentRoles" :key="item.id">
                      <a href="javascript:void(0);" class="right_content_a">
                        {{item.name}}
                        <input type="checkbox" class="actions-select" :class="{'focus': item.selected }" @click="itemCheckedWithUI($event, $event.target.checked, item, '04')" v-model="item.selected" />
                      </a>
                    </p>
                  </dd>
                  <h5 class="none_ts" v-else>
                    <img src="@/assets/images/none_data.jpg" alt="">
                  </h5>
                </dl>
              </div>
            </div>
            <div v-show="current.name == 'tag'">
              <div v-if="currentTags && currentTags.length == 0">
                暂无可用标签
              </div>
              <div v-if="currentTags && currentTags.length > 0" style="height: 218px; padding: 5px; overflow: scroll;">
                <div v-for="item in currentTags" :key="item.id" :class="[item.checked ? 'tag-checked': 'tag-item']" @click="tagChecked(item, $event, '04')">
                  {{item.content}}
                </div>
              </div>
              <div class="right_height" style="height:218px; margin-top: 0; border-left: 0; padding-left: 0;">
                <dl>
                  <dt style="margin-bottom: 0; font-weight: 900;">标签对应公司/人员</dt>
                  <dd class="right_content" style="overflow-y: scroll; height: 180px;">
                    <p class="horizontal" v-if="tagItems.length > 0" v-for="item in tagItems" :key="item.id" :class="{'bumeng-icon': tagItemType == '02', '': tagItemType == '01'}">
                      <a href="javascript:void(0);" class="right_content_a">
                        {{item.name}}
                        <input type="checkbox" class="actions-select actions-select-inline" :class="{'focus': item.selected }" @click="itemCheckedWithUI($event, $event.target.checked, item, (tagItemType == '01') ? '02' : '01')" v-model="item.selected" />
                      </a>
                    </p>
                    <h5 class="none_ts" v-if="tagItems.length == 0">
                      <img src="@/assets/images/none_data.jpg" height="180">
                    </h5>
                  </dd>
                </dl>
              </div>
            </div>
            <div v-show="current.name == 'custom'">
    <!--          <input type="radio" value="0" v-model="customSearchTrigger" class="actions-select" :class="{'focus': customSearchTrigger == '0'}" style="float: none; top: 0px;"> 模糊查询
              <input type="radio" value="1" v-model=" customSearchTrigger" class="actions-select" :class="{'focus': customSearchTrigger == '1'}" style="float: none; top: 0px;"> 精准查询-->
              <div v-if="customSearchTrigger == '0'" style="margin-top: 5px;">
                <input class="custom_input" v-model="customSearchFilter.name" type="text" placeholder="输入部门，人员，手机，邮箱等"  />
                <span class="xo-table-btn" @click="customSearch(customSearchFilter)">搜索</span>
                <input-excel title="导入人员" @getResult="importUsers"></input-excel>
                <a style="cursor: pointer; text-decoration: underline;" :href="downLoadLink">导入模板</a>
                <div class="right_height" style="height:218px; margin-top: 0; border-left: 0; padding-left: 0;">
                  <dl>
                    <dd class="right_content" style="overflow-y: scroll; height: 400px;">
                      <p class="horizontal" v-if="customSearchResult.length > 0" v-for="item in customSearchResult" :key="item.id" :class="{'bumeng-icon': item.uitype == '01', 'wangwei-icon': item.uitype == '03', 'tag-icon': item.uitype == '04'}">
                        <a href="javascript:void(0);" class="right_content_a">
                          {{item.name}}
                          <input type="checkbox" class="actions-select actions-select-inline" :class="{'focus': item.selected }" @click="itemCheckedWithUI($event, $event.target.checked, item, item.uitype)" v-model="item.selected" />
                        </a>
                      </p>
                      <h5 class="none_ts" v-if="customSearchResult.length == 0">
                        <img src="@/assets/images/none_data.jpg" height="180">
                      </h5>
                    </dd>
                  </dl>
                </div>
              </div>
              <!--<div v-if="customSearchTrigger == '1'">
                <exact-search :options="options" :treemenu="treemenu" :tags="currentTags" @changed="exactSearch"></exact-search>
              </div>-->
            </div>
          </div>
        </div>
      </div>
      <!--/左侧组织-->
      <!--右侧已选组织和人员-->
      <div class="col_2 w365 right_height" style="height:480px;">
        <dl>
          <dt>已选择的部门/人员/用户/标签<a href="javascript:void(0);" class="emptyBtn" @click="clear()">清空</a></dt>
          <dd class="right_content">
            <p v-for="item in outputs" :key="item.id" :class="{'bumeng-icon': item.uitype == '01', 'wangwei-icon': item.uitype == '03', 'tag-icon': item.uitype == '04'}">
              <a href="javascript:void(0);" class="right_content_a">
                {{item.name}}
                <!-- uitype: {{item.uitype}} -->
                <span @click="del(item)"></span>
              </a>
            </p>
          </dd>
        </dl>
      </div>
      <!--/右侧已选组织和人员-->
    </div>
</template>

<script>
    // import Async from '@/components/common/common/asynComponent.vue'
    import api from '@/api/index'
    import config from '@/config/index'
    import TreeView  from '@/components/common/treeview/index.vue'
    import Paginate from 'vuejs-paginate'
    import utils from '@/utils'
    import difference from 'lodash.differenceby'
    import clonedeep from 'lodash.clonedeep'
    import { mapState, mapActions, mapGetters } from 'vuex'
    import inputExcel from '@/components/common/xlsx-reader'
    import exactSearch from '@/components/byl/rangeManip/exactSearch'
    export default {
      components: { TreeView, Paginate, inputExcel, exactSearch },
      created () {
        this.initData()
        /* this.getUsers({pageNo: 1, pageSize: 40}).then((r) => { // 异步获取用户信息
          this.pages = Math.ceil(r.cntData / 40)
          this.cnt = r.cntData
        }) */
        this.getTags().then((r) => {
          if (r) {
            this.$utils.setVal(r, 'checked', false)
            this.currentTags = r
          } else {
            this.currentTags = []
          }
        })
        if (this.params.inputs && utils.isArray(this.params.inputs)) {
          this.outputs = this.params.inputs
        }
        if (this.params.inputs && utils.isObject(this.params.inputs)) {
          this.outputs.form.title = this.params.inputs.title
          this.outputs.form.content = this.params.inputs.content
        }
        if (this.params.treeViewOptions) {
          this.options = Object.assign(this.options, this.params.treeViewOptions)
        }
        if (this.params.tabs) {
          for (let j = 0; j < this.tabsData.length; j++) {
            let isFound = utils.findElem(this.params.tabs, this.tabsData[j].name)
            if (isFound > -1) {
              this.tabsData[j].available = true
              this.current = this.tabsData[j]
            } else {
              this.tabsData[j].available = false
            }
          }
        } else {
          this.current = this.tabsData[0]
        }
      },
      watch: {
        getCurrentDepts (val) { // 异步获取到的所有部门数据需要用watch
          this.treemenu = val
          this.options.selectedNodes = this.outputs.filter((val) => {
            return val.type !== '03'
          })
        },
        getCurrentList (val) { // 异步获取到的所有部门下面的人员数据需要用watch
          var l = this.outputs
          this.currentPeople = val
          utils.setVal(this.currentPeople, 'type', '03')
          this.setSelected({sourcearr: l, targetarr: this.currentPeople, foundKey: 'id', targetMark: 'selected', targetVal: true})
        },
        getCurrentUsers (val) {
          var l = this.outputs
          this.currentUsers = val
          for (let i = 0; i < this.currentUsers.length; i++) {
            var o = this.currentUsers[i]
            if (o.username) {
              o.name = o.username
            } else { // 没有用户名，用accountNames, 账户是肯定有的
              o.name = o.accountNames[0]
            }
            o.type = '04'  // 用户
          }
          this.setSelected({sourcearr: l, targetarr: this.currentUsers, foundKey: 'id', targetMark: 'selected', targetVal: true})
        },
        getCurrentRoles (val) {
          this.currentRoles = val
          for (let i = 0; i < this.currentRoles.length; i++) {
            var o = this.currentRoles[i]
            o.type = '05'  // 角色
          }
          let d = this.outputs.filter((val) => {
            return val.type == '05'
          })
          for (let i = 0; i < d.length; i++) {
            let idx = utils.findElem(this.currentRoles, 'id', d[i].id)
            this.currentRoles[idx].selected = true
          }
        },
        currentTags (val) {
          this.currentTags = val
          utils.setVal(this.currentTags, 'tagType', '06')
          let d = this.outputs.filter((val) => {
            return val.tagType == '06'
          })
          this.setSelected({sourcearr: d, targetarr: this.currentTags, foundKey: 'id', targetMark: 'checked', targetVal: true})
        },
        getDimension (val) {
          this.options.boxStyle.width = val.menusWidth
          this.options.depth = val.depth
        },
        'current': {
          handler (newVal, oldVal) {
            var l = this.outputs; // 深复制对象
            switch (newVal.name) {
              case 'custom': {
                this.setSelected({sourcearr: l, targetarr: this.customSearchResult, foundKey: 'id', targetMark: 'selected', targetVal: true}) // 控制的是点击用户，影响自定义搜索
                break
              }
              case 'org': {
                this.options.selectedNodes = l.filter((val) => {
                  return val.type !== '03'
                })
                this.setSelected({sourcearr: l, targetarr: this.currentPeople, foundKey: 'id', targetMark: 'selected', targetVal: true})
                break
              }
              case 'user': {
                this.setSelected({sourcearr: l, targetarr: this.currentUsers, foundKey: 'id', targetMark: 'selected', targetVal: true})
                break
              }
              case 'tag': {
                this.setSelected({sourcearr: l, targetarr: this.currentTags, foundKey: 'id', targetMark: 'checked', targetVal: true})
                break
              }
            }
          },
          deep: true
        }
      },
      computed: {
        ...mapState('orgstructure', ['menus', 'dept', 'list']),
        ...mapGetters('orgstructure', ['getCurrentList', 'getCurrentDepts', 'getCurrentDept', 'getDimension']),
        ...mapGetters('users', ['getCurrentUsers', 'getCurrentRoles'])
      },
      props: ['params'],
      data () {
        var that = this
        return {
          downLoadLink: config.scope_sheets,
          menusWidth: '',
          customSearchTrigger: '0',
          asyncFlag1: false, // 加载标识1
          asyncFlag2: false, // 加载标识2
          pages: 0,
          cnt: 0,
          current: {},
          customSearchFilter: {
            name: ''
          },
          userSearchFilter: {
            name: '',
            pageNo: '1',
            pageSize: '40'
          },
          customSearchResult: [],
          exactSearchResult: [],
          userSearchResult: [],
          options: { // 树形菜单的Options
            parentNodeClickable: true, //  点击有子菜单的node是否可以发出事件
            multiselect: true, // 是否允许多选
            editMode: false, // 是否允许编辑/删除
            searchMode: true, // 是否提供过滤
            semiCheck: true, // 是否提供全选（选中父级则勾选中所有子级）
            hasScroll: true,
            boxStyle: {
              width: that.menusWidth,
              height: '400px'
            },
            nodeSelected: function (check, val) { // checkbox选中后的回调 check: checkbox是否被选中 val：节点的值
              if (val) {
                that.addUIType(val, 'uitype', '01')
                if (this.semiCheck && val.children) {
                  var r = []
                  r.push(val) // 要将点击的节点(自己)加入数组
                  var result = utils.flattern(val.children) // 将数组里的children取出来拉平
                  utils.setVal(result, 'uitype', '01')
                  if (check) {
                    if (that.outputs && that.outputs.length > 0) { // 原来就有值
                      that.outputs = that.outputs.concat(r.concat(result))
                    } else {
                      that.outputs = r.concat(result)
                    }
                  } else {
                    that.outputs = difference(that.outputs, r.concat(result), 'id')  // 求差集
                  }
                } else { // 没有children的节点被点中
                  that.itemChecked(check, val)
                }
              }
            },
            selectedNodes: that.params.inputs // 选中的节点，一般用于初始化
          },
          treemenu: [], // 该值在组件内部会监听变化的,只有改变这个值,树形菜单组件内部才会更新
          currentPeople: [],
          currentUsers: [], // 所有用户
          currentRoles: [],
          currentTags: [], // 所有可用标签
          tagItems: [], // 标签对应的Items
          tagItemType: '', // 标签使用的分类
          tabsData: [
            {
              name: 'org',
              tabName: '按组织架构',
              path: 'page/byl/org/plan/model.vue',
              available: true
            },
            {
              name: 'user',
              tabName: '按注册用户',
              path: 'page/be',
              available: true
            },
            {
              name: 'role',
              tabName: '按角色',
              path: 'page/be',
              available: false
            },
            {
              name: 'tag',
              tabName: '按标签',
              available: true
            },
            {
              name: 'custom',
              tabName: '自定义搜索',
              available: true
            }
          ],
          outputs: [] // 出口
        }
      },
      methods: {
        ...mapActions('orgstructure', ['getDepts', 'addDept', 'delDept', 'getPersonByDept', 'getPeopleByDept', 'setDept', 'addPerson']),
        ...mapActions('users', ['getUsers', 'getRoles']),
        initData () {
          return new Promise((resolve, reject) => {
            this.getDepts().then((r) => { // 异步获取部门信息 之后会默认去取部门下的人员
              this.asyncFlag1 = true
              if (r) {
                resolve(r)
                let ids = this.getIds(r[0])
                this.getPeopleByDept({depList: ids}).then((r) => {
                  this.asyncFlag2 = true
                })
              }
            })
          })
        },
        nodeClicked (node) { // 获取部门下面的人员
          this.asyncFlag2 = false
          this.setDept(node)
          let ids = this.getIds(node)
          this.getPeopleByDept({ depList: ids }).then((r) => {
            this.asyncFlag2 = true
          })
        },
        getIds (node) {
          let ids
          if (node.children) {
            let childs = utils.flattern(node.children)
            ids = utils.grabVal(childs.concat(node), 'id')
          } else {
            ids = [node.id]
          }
          return ids
        },
        del (item) {
          var idx = utils.findElem(this.outputs, 'id', item.id)
          var t = item.type
          var tt = item.tagType
          this.outputs.splice(idx, 1)
          this.setSelected2(t, tt, item)
        },
        setSelected (o) {
          if (o.sourcearr.length > 0) {
            if (o.sourcearr.length < o.targetarr.length) { // !!!特殊情况
              utils.setVal(o.targetarr, o.targetMark, false)
            }
            for (let i = 0; i < o.sourcearr.length; i++) {
              let idx = utils.findElem(o.targetarr, o.foundKey, o.sourcearr[i][o.foundKey])
              if (idx > -1) {
                o.targetarr[idx][o.targetMark] = o.targetVal
              } else {
                if (o.targetarr[i]) {
                  o.targetarr[i][o.targetMark] = !o.targetVal
                }
              }
            }
          } else {
            utils.setVal(o.targetarr, o.targetMark, false)
          }
        },
        setSelected2 (t, tt, item) {
          var _setTo = function (arr, key) {
            var idx = utils.findElem(arr, 'id', item.id)
            if (idx > -1) {
              arr[idx][key] = false
            }
          }
          if (this.customSearchResult.length > 0) {
            _setTo(this.customSearchResult, 'selected')
          }
          if (this.tagItems.length > 0) {
            _setTo(this.tagItems, 'selected')
          }
          if (t == '03') { // 更新人员选中状态
            _setTo(this.currentPeople, 'selected')
          } else if (t == '04') { // 更新用户选中状态
            _setTo(this.currentUsers, 'selected')
          } else if (t == '05') { // 更新角色选中状态
            _setTo(this.currentRoles, 'selected')
          } else if (tt) { // 更新标签选中状态
            _setTo(this.currentTags, 'checked')
          } else { // 更新部门选中状态
            this.getDepts()
          }
        },
        getTags (filter) {
          var that = this
          return new Promise(function (resolve, reject) {
            that.$api.post(that.$global.tagApiPath, '/tagInfo/findList', filter, r => {
              resolve(r.data)
            })
          })
        },
        getItems(item) {
          this.tagItemType = item.type
          if (item.type == '01') {
            this.getMembersByTag(item).then((r) => {
              if (r) {
                this.tagItems = r
              } else {
                this.tagItems = []
              }
            })
          } else if (item.type == '02') {
            this.getDeptsByTag(item).then((r) => {
              if (r) {
                this.tagItems = r
              } else {
                this.tagItems = []
              }
            })
          }
        },
        userSearch (filters) {
          if (!filters) { filters = {} }
          if (filters.name) {
            filters.name = filters.name.replace(/\s/g, "")
          }
          var that = this
          return new Promise(function (resolve, reject) {
            api.post(config.bylApiPath, '/entUser/findAccountInfo', filters, function (r) { // 正常
              that.pages = Math.ceil(r.cntData / filters.pageSize)
              that.cnt = r.cntData
              if (r.data) {
                that.currentUsers = r.data
                for (let i = 0; i < that.currentUsers.length; i++) {
                  var o = that.currentUsers[i]
                  o.id = o.userId
                  o.type = '04'  // 用户
                }
                that.setSelected({sourcearr: that.outputs, targetarr: that.currentUsers, foundKey: 'id', targetMark: 'selected', targetVal: true})
              } else {
                that.currentUsers = []
              }
            })
          })
        },
        customSearch (filter) {
          this.customSearchRequest(filter).then((r) => {
            if (r) {
              this.customSearchResult = r
            } else {
              this.customSearchResult = []
            }
            if (this.customSearchResult.length > 0) {
              for (let i = 0; i < this.customSearchResult.length; i++) {
                var o = this.customSearchResult[i]
                let t = this.customSearchResult[i].type
                switch (t) {
                  case '1': { // 标签
                    o.tagType = '06'
                    this.addUIType(o, 'uitype', '04')
                    break
                  }
                  case '2': { // 用户
                    this.addUIType(o, 'uitype', '03')
                    o.type = '04'
                    break
                  }
                  case '3': { // 人员
                    this.addUIType(o, 'uitype', '02')
                    o.type = '03'
                    break
                  }
                  case '4': { // 公司
                    this.addUIType(o, 'uitype', '01')
                    o.type = ''
                    break
                  }
                }
              }
            }
            if (this.customSearchResult.length > 0) {
              this.setSelected({sourcearr: this.outputs, targetarr: this.customSearchResult, foundKey: 'id', targetMark: 'selected', targetVal: true})
            }
          })
        },
        customSearchRequest (filter) {
          var that = this
          return new Promise(function (resolve, reject) {
            that.$api.get(that.$global.bylApiPath, '/msg/searchMsgTarget', filter, r => {
              resolve(r.data)
            })
          })
        },
        exactSearch (obj) { // 精准搜索
          var o = {}
          if (obj.deps && obj.deps.length > 0) { o.depIdList = utils.grabVal(obj.deps, 'id') }
          if (obj.tags && obj.tags.length > 0) { o.tagIdList = utils.grabVal(obj.tags, 'id') }
          o.post = obj.post
          this.$api.post(this.$global.bylApiPath, '/msg/exactSearch', o, r => {
            var result = []
            if (r.data) {
              r.data.forEach((o) => {
                result.push({
                  id: o.memberId,
                  name: o.memberName,
                  uitype: '02'
                })
              })
            } else {
              result = []
            }
            if (this.outputs && this.outputs.length > 0) {
              let r1 = clonedeep(this.outputs)
              var result2 = []
              r1.forEach((o) => {
                result2.push({
                  id: o.id,
                  name: o.name,
                  uitype: '02'
                })
              })
              this.outputs = result2.concat(difference(result, result2, 'id'))
            } else {
              this.outputs = result
            }
          })
        },
        getMembersByTag (item) {
          var that = this
          return new Promise(function (resolve, reject) {
            that.$api.post(that.$global.bylApiPath, '/msg/tagSearchByMember', {tagId: item.id}, r => {
              resolve(r.data)
            })
          })
        },
        getDeptsByTag (item) {
          var that = this
          return new Promise(function (resolve, reject) {
            that.$api.post(that.$global.bylApiPath, '/msg/tagSearchByDep', {tagId: item.id}, r => {
              resolve(r.data)
            })
          })
        },
        clickCallback (pageNum)  {
          this.userSearchFilter.pageNo = pageNum
          this.userSearch(this.userSearchFilter).then((r) => { // 异步获取用户信息
            this.pages = Math.ceil(r.cntData / 40)
            this.cnt = r.cntData
          })
        },
        clear () {
          this.outputs = [];
          this.options.selectedNodes = [];
          this.initData()
        },
        addUIType (o, key, val) {
          o[key] = val
        },
        itemCheckedWithUI (e, checked, item, uitype) { // 选中人员02，用户03
          item.selected = !item.selected
          this.addUIType(item, 'uitype', uitype)
          this.itemChecked(e.target.checked, item)
        },
        itemChecked (check, item) {
          var idIndex = utils.findElem(this.outputs, 'id', item.id)
          if (check) {
            if (idIndex > -1) { /* 已存在的item不能再添加了 */
              return false;
            } else {
              this.outputs.push(item)
            }
          } else {
            this.outputs.splice(idIndex, 1)
          }
        },
        clickEffects (e) {
          var $elem = $(e.target)
          if ($elem.is('input')) {
            $elem.toggleClass('focus')
          }
        },
        tagChecked (item, $event, uitype) { // 选中标签
          this.addUIType(item, 'uitype', uitype)
          this.getItems(item);
          this.checkedOne(item, $event)
        },
        checkedOne (item) {
          item.checked = !item.checked
          item.name = item.content
          item.tagType = '06'
          let idIndex =  this.$utils.findElem(this.outputs, 'id', item.id)
          if (idIndex >= 0) {
            this.outputs.splice(idIndex, 1)
          } else {
            this.outputs.push(item)
          }
        },
        importUsers (data) {
          var r = []
          if (data && data.length > 0) {
            data.forEach((o) => {
              r.push({
                id: o['学员id'],
                name: o['姓名'],
                uitype: '02'
              })
            })
            this.outputs = r
          }
        }
      }
    }
</script>

<style scoped>
  @import './index.css';
</style>



// WEBPACK FOOTER //
// src/components/byl/rangeManip/index.vue